import { API_BASE_URL } from '@/environment'
import { apiV3 } from '@/service/v3/apiV3'
import { customFetch } from '@/service/v3/apiV3Utils'
import type {
  getProductsUserActivitySummaryParams,
  rejectUserActivityTaskParams,
} from './activitiesTypes'

export const getProductsUserActivitySummary = async ({
  productId,
  userId,
}: getProductsUserActivitySummaryParams) => {
  const url = `${API_BASE_URL}/api/v3/admin/products/${productId}/users/${userId}/activity_summary`
  return customFetch(url, {
    method: 'GET',
  }).then((response) => response.json())
}

export const getProductActivityItems = (productId: string | number) => {
  return apiV3.products.getProductActivityItems(String(productId))
}

export const rejectUserActivityTask = async ({
  productId,
  activityItemUserId,
  userId,
}: rejectUserActivityTaskParams) => {
  const url = `${API_BASE_URL}/api/v3/admin/products/${productId}/user_activity_summary/${userId}/reject_activity_task/${activityItemUserId}`
  return customFetch(url, {
    method: 'DELETE',
  })
}
